/**
 * Compact dropdown filter for `model_category` (SCOOTER / MOPED / MOTORCYCLE
 * / PREMIUM / SUPER PREMIUM / ELECTRIC / COMMERCIAL / OTHER).
 *
 * Shared by Sales, Inventory, and Bookings list pages so the look + behaviour
 * stays uniform. Value is upper-case; empty string ⇒ "all".
 */
import { MODEL_CATEGORY_OPTIONS } from "@/components/PackageFormDrawer";

export default function ModelCategoryFilter({ value, onChange, testId = "model-category-filter" }) {
  return (
    <div className="flex items-center gap-2">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-muted">
        Model:
      </span>
      <select
        data-testid={testId}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="px-3 py-2 bg-canvas border border-canvas-line text-sm focus:outline-none focus:border-ink"
      >
        <option value="">All models</option>
        {MODEL_CATEGORY_OPTIONS.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
    </div>
  );
}
